const userReducer = (user = null ,action) => {
    switch(action.type){
        case 'ADDUSER':
            return user = action.payload

        case 'EDITUSER':
            var definedUser = user
            if(user.email === action.payload.email){
                definedUser = action.payload
            }
            return definedUser

        case "DELETEUSER":
            return user = null
        default:
            return user;
    }

}

export default userReducer;